export default __webpack_public_path__ + "static/media/discord.f7affe1a.svg";